import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { X } from '@finect/tabular-icons/x';
import { getProductName } from '../../../Products/utils';
import { Circle } from '../partials/ControlButton/partials';
import { Inner, Name, DeleteContainer } from './partials';
export var CellFund = function CellFund(_ref) {
  var getSheetPath = _ref.getSheetPath,
    productType = _ref.productType,
    fund = _ref.fund,
    index = _ref.index,
    onDeleteAction = _ref.onDeleteAction,
    _ref$minimal = _ref.minimal,
    minimal = _ref$minimal === void 0 ? false : _ref$minimal;
  if (minimal) {
    return React.createElement(Inner, null, React.createElement(Name, {
      isMinimal: minimal
    }, getProductName(productType, fund)));
  }
  return React.createElement(Inner, null, onDeleteAction ? React.createElement(DeleteContainer, {
    onClick: onDeleteAction
  }, React.createElement(X, null)) : null, React.createElement(Name, {
    isMinimal: minimal
  }, React.createElement(AppLink, {
    key: "fund-name",
    href: getSheetPath(productType, fund)
  }, getProductName(productType, fund))), React.createElement("div", null, React.createElement(Circle, {
    horizontal: true,
    radius: 6,
    index: index
  })));
};